import { Instagram } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const POSTS = ["/images/ig-1.jpg", "/images/ig-2.jpg", "/images/ig-3.jpg", "/images/ig-4.jpg"];

const InstagramSection = () => (
  <section id="instagram" className="scroll-mt-24 bg-[#F4EFEB] py-24 sm:py-32" data-testid="instagram-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Chapter num="08" label="Instagram" />
      </Reveal>
      <div className="mt-6 flex flex-wrap items-end justify-between gap-6">
        <Reveal delay={0.1}>
          <h2 className="font-display text-4xl font-light leading-tight tracking-tight text-[#2D2422] sm:text-5xl">
            Follow Along
          </h2>
          <p className="mt-4 font-accent text-sm font-medium tracking-wide text-[#8A7975]">@bellabellscakes</p>
        </Reveal>
        <Reveal delay={0.2}>
          <a
            href="https://www.instagram.com/bellabellscakes"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            data-testid="instagram-follow-btn"
          >
            <Instagram size={16} strokeWidth={1.5} /> Follow Bella Bells Cakes
          </a>
        </Reveal>
      </div>

      <div className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-4" data-testid="instagram-grid">
        {POSTS.map((src, i) => (
          <Reveal key={src} delay={i * 0.08}>
            <a
              href="https://www.instagram.com/bellabellscakes"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block overflow-hidden rounded-2xl border border-[#E8D8D3]/60"
              data-testid={`instagram-post-${i + 1}`}
            >
              <img
                src={src}
                alt="Bella Bells Cakes on Instagram"
                loading="lazy"
                className="aspect-square w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <span className="absolute inset-0 flex items-center justify-center bg-[#2D2422]/0 transition-colors duration-500 group-hover:bg-[#2D2422]/30">
                <Instagram size={22} className="text-white opacity-0 transition-opacity duration-500 group-hover:opacity-100" strokeWidth={1.5} />
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default InstagramSection;
